<template>
  <div class="hot-special-topic">
    <sn-header text="热门专题" @change="onToggleStatusChange"></sn-header>
    <el-collapse-transition>
      <div class="special-topic" v-if="conditionsShow">
        <hot-item v-for="(stock, index) in hotSpecialTopic" :key="index" :class="{active: activeIndex === index}" :item="stock" @click.native="onItemClick(stock)"></hot-item>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import SnHeader from '@/components/common/SnHeader';
import HotItem from '@/components/common/HotItem';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      conditionsShow: true,
      activeIndex: -1,
      hotSpecialTopic: []
    };
  },
  methods: {
    onToggleStatusChange(res) {
      this.conditionsShow = res;
    },
    requestHotSpecialTopic() {
      this.hotSpecialTopic = [];
      QuestionQuery.getHotSpecialTopic().then(res => {
        this.hotSpecialTopic = res.data;
      });
    },
    onItemClick(res) {
      const params = {
        title: {
          include: res,
          exclude: ''
        },
        text: {
          include: '',
          exclude: ''
        },
        sortOrder: '',
        sortBy: '',
        pdfSize: {
          max: 0,
          min: 0
        },
        pageSize: 20,
        pageNum: 1,
        institution: [],
        industry: [],
        genre:[],
        date: {
          start: '',
          end: ''
        },
        category: []
      };
      this.$emit('mySearchCondition', params);
    }
  },
  components: {
    SnHeader,
    HotItem
  },
  mounted() {
    this.requestHotSpecialTopic();
  }
};
</script>
<style lang="scss" scoped>
.hot-special-topic {
  .special-topic {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    padding: 16px;
    background-color: #ffffff;
    .active {
      color: #0750E0;
      font-weight: bold;
    }
  }
}
</style>
